/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Data_Protection_TitleInputs */

const en_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Data Protection`)
};

const de_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Datenschutz`)
};

const fr_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Protection des données`)
};

const es_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Protección de datos`)
};

const it_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Protezione dei dati`)
};

const nl_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Gegevensbescherming`)
};

const pl_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Ochrona danych`)
};

const fi_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Tietosuoja`)
};

const da_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Databeskyttelse`)
};

const sv_agb_data_protection_title = /** @type {(inputs: Agb_Data_Protection_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Dataskydd`)
};

/**
* | output |
* | --- |
* | "9. Data Protection" |
*
* @param {Agb_Data_Protection_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_data_protection_title = /** @type {((inputs?: Agb_Data_Protection_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Data_Protection_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_data_protection_title(inputs)
	if (locale === "fr") return fr_agb_data_protection_title(inputs)
	if (locale === "es") return es_agb_data_protection_title(inputs)
	if (locale === "it") return it_agb_data_protection_title(inputs)
	if (locale === "nl") return nl_agb_data_protection_title(inputs)
	if (locale === "pl") return pl_agb_data_protection_title(inputs)
	if (locale === "fi") return fi_agb_data_protection_title(inputs)
	if (locale === "da") return da_agb_data_protection_title(inputs)
	if (locale === "sv") return sv_agb_data_protection_title(inputs)
	return en_agb_data_protection_title(inputs)
});